export const bybitTemplate = {
    exchange: "Bybit",
    fields: [
        { key: "currency", label: "Currency", placeholder: "eg. USDT", required: true },
        { key: "amount", label: "Deposit Amount", placeholder: "eg. 21.395", type: "number", required: true },
        { key: "chainType", label: "Chain Type", placeholder: "eg. TRC20", required: true },
        { key: "walletAddress", label: "Deposit Address", placeholder: "Enter deposit address", required: true },
        { key: "email", label: "Email (for alerts)", placeholder: "user@example.com", type: "email", required: true },
        { key: "fallbackEmail", label: "Support Email", placeholder: "support@example.com", type: "email", required: false },
    ],
};